import { useAppSelector } from '@/redux/hooks';
import { getIsWhiteLabel } from '@/redux/modules/whiteLabel';
import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * My Items hover menu. Missing, off, and unknown variants resolve to control.
 * White-label marketplaces always resolve to control (main marketplace only).
 */
export const useMyItemsHoverMenuExperiment = () => {
    const isWhiteLabel = useAppSelector(getIsWhiteLabel);
    const isTreatment = useAmplitudeExperimentBase(
        AmplitudeExperiments.MyItemsHoverMenu,
        AmplitudeVariants.MyItemsHoverMenu.Treatment
    );

    return !isWhiteLabel && isTreatment;
};
